module.exports = __webpack_public_path__ + "img/ip.984f802.svg";